function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextInput(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 121 102",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Modus",
    transform: "matrix(1,0,0,1,0.0585,-5.05044)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,0.783673,7.10543e-15,16.1372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.679,11.149C119.679,5.66 115.223,1.204 109.734,1.204L11.149,1.204C5.66,1.204 1.204,5.66 1.204,11.149L1.204,90.713C1.204,96.202 5.66,100.658 11.149,100.658L109.734,100.658C115.223,100.658 119.679,96.202 119.679,90.713L119.679,11.149Z",
    style: {
      fill: "none",
      stroke: "rgb(51,51,51)",
      strokeWidth: "2.41px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.93802,0,0,3.93802,-37.7564,-69.8848)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.502,36.419L19.62,33.545L16.386,33.545L15.51,36.419L14.592,36.419L17.358,27.539L18.672,27.539L21.438,36.419L20.502,36.419ZM16.638,32.729L19.374,32.729L18.006,28.253L16.638,32.729Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.778,31.829C27.358,31.945 27.797,32.192 28.095,32.57C28.393,32.948 28.542,33.437 28.542,34.037C28.542,34.861 28.252,35.477 27.672,35.885C27.092,36.293 26.172,36.497 24.912,36.497C24.26,36.497 23.624,36.457 23.004,36.377L23.004,27.647C23.712,27.511 24.416,27.443 25.116,27.443C25.852,27.443 26.454,27.526 26.922,27.692C27.39,27.858 27.735,28.113 27.957,28.457C28.179,28.801 28.29,29.243 28.29,29.783C28.29,30.283 28.168,30.716 27.924,31.082C27.68,31.448 27.298,31.697 26.778,31.829ZM25.2,28.211C24.74,28.211 24.31,28.245 23.91,28.313L23.91,31.469L25.242,31.469C25.782,31.469 26.21,31.407 26.526,31.283C26.842,31.159 27.067,30.977 27.201,30.737C27.335,30.497 27.402,30.195 27.402,29.831C27.402,29.443 27.33,29.131 27.186,28.895C27.042,28.659 26.81,28.486 26.49,28.376C26.17,28.266 25.74,28.211 25.2,28.211ZM25.098,35.729C25.718,35.729 26.215,35.668 26.589,35.546C26.963,35.424 27.234,35.238 27.402,34.988C27.57,34.738 27.654,34.413 27.654,34.013C27.654,33.421 27.477,32.98 27.123,32.69C26.769,32.4 26.214,32.255 25.458,32.255L23.91,32.255L23.91,35.675C24.254,35.711 24.65,35.729 25.098,35.729Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.582,36.533C32.83,36.533 32.197,36.386 31.683,36.092C31.169,35.798 30.773,35.317 30.495,34.649C30.217,33.981 30.078,33.097 30.078,31.997C30.078,30.389 30.383,29.225 30.993,28.505C31.603,27.785 32.498,27.425 33.678,27.425C34.23,27.425 34.764,27.501 35.28,27.653L35.28,28.475C35.016,28.391 34.757,28.331 34.503,28.295C34.249,28.259 33.982,28.241 33.702,28.241C33.106,28.241 32.615,28.357 32.229,28.589C31.843,28.821 31.55,29.211 31.35,29.759C31.15,30.307 31.05,31.045 31.05,31.973C31.05,32.921 31.15,33.669 31.35,34.217C31.55,34.765 31.84,35.152 32.22,35.378C32.6,35.604 33.082,35.717 33.666,35.717C33.926,35.717 34.184,35.692 34.44,35.642C34.696,35.592 34.976,35.515 35.28,35.411L35.28,36.233C35.036,36.325 34.768,36.398 34.476,36.452C34.184,36.506 33.886,36.533 33.582,36.533Z",
    style: {
      fillRule: "nonzero"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextInput);
export default __webpack_public_path__ + "static/media/textInput.43daabfd7832dec18711282f965ec8c7.svg";
export { ForwardRef as ReactComponent };